<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>

  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h1 class="mb-0 text-center w-100">Application</h1>
        </div>

        <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
          <mat-tab label="Application settings">
            <div class="tab-content pt-3">
              <modernization-application-settings [embedded]="true" />
            </div>
          </mat-tab>

          <mat-tab label="POD's List">
            <div class="tab-content pt-3">
              <modernization-pods-list [embedded]="true" />
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </section>
</main>